import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { SolutionIntro } from './components/SolutionIntro';
import { WhatYouReceive } from './components/WhatYouReceive';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
// Lazy load below-fold components for better initial load performance
const Guarantee = lazy(() => import('./components/Guarantee').then(mod => ({
  default: mod.Guarantee
})));
const Testimonials = lazy(() => import('./components/Testimonials').then(mod => ({
  default: mod.Testimonials
})));
const FAQ = lazy(() => import('./components/FAQ').then(mod => ({
  default: mod.FAQ
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(mod => ({
  default: mod.FinalCTA
})));
const Footer = lazy(() => import('./components/Footer').then(mod => ({
  default: mod.Footer
})));
const SocialProofPopup = lazy(() => import('./components/SocialProofPopup').then(mod => ({
  default: mod.SocialProofPopup
})));
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Defer Meta Pixel loading to improve initial page load
    const loadFacebookPixel = () => {
      if (!window.fbq) {
        const n: any = window.fbq = function (...args: unknown[]) {
          if (n.callMethod) {
            n.callMethod.apply(n, args);
          } else {
            n.queue.push(args);
          }
        };
        if (!window._fbq) window._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const t = document.createElement('script');
        t.async = true;
        t.defer = true;
        t.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const s = document.getElementsByTagName('script')[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        }
      }
      window.fbq('init', '1687764378881323');
      window.fbq('track', 'PageView');
      // Add noscript pixel fallback
      const noscriptImg = document.createElement('img');
      noscriptImg.height = 1;
      noscriptImg.width = 1;
      noscriptImg.style.display = 'none';
      noscriptImg.src = 'https://www.facebook.com/tr?id=1687764378881323&ev=PageView&noscript=1';
      noscriptImg.alt = '';
      document.body.appendChild(noscriptImg);
    };
    // Defer pixel loading until after initial render
    const timeoutId = setTimeout(loadFacebookPixel, 1000);
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);
  return <div className="w-full min-h-screen bg-[#0a0a0a] text-white overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainPoints data-id="element-2" />
      <SolutionIntro data-id="element-3" />
      <WhatYouReceive data-id="element-4" />
      <BonusSection data-id="element-5" />
      <PricingSection data-id="element-6" />
      <Suspense fallback={<div className="min-h-[200px]" data-id="element-8" />} data-id="element-7">
        <Guarantee data-id="element-9" />
        <Testimonials data-id="element-10" />
        <FAQ data-id="element-11" />
        <FinalCTA data-id="element-12" />
        <Footer data-id="element-13" />
        <SocialProofPopup data-id="element-14" />
      </Suspense>
    </div>;
}